import { useAppSelector } from "../../../hooks"
import { brandOptions as brandOptionsStored } from "../../../../redux/slices/conversations"

const Options = () => {
  const brandOptions = useAppSelector(brandOptionsStored)

  return (
    <>
      <option value="">All Brands</option>
      {brandOptions?.map(brand => (
        <option key={brand.id} value={brand.id}>
          {brand.name.replace(/,$/, "")}
        </option>
      ))}
    </>
  )
}

export default Options
